import { Component, Input, inject, computed } from '@angular/core';
import { AppleCareItem, ConfigurationService, DisabledEngravingModalData, EngravingModalService } from '@core';
import { formatRewardAmount } from '@models';

@Component({
  selector: 'app-apple-care-listing',
  templateUrl: './apple-care-listing.component.html',
  styleUrls: ['./apple-care-listing.component.scss'],
  imports: [],
})
export class AppleCareListingComponent {
  protected readonly rewardName = inject(ConfigurationService).rewardName;
  @Input() appleCareItem: AppleCareItem | null = null;
  @Input() isEngravable = false;
  @Input() engravingText: string | null = null;
  @Input() isOrderReview = false;
  /** Admin-panel keeps US dollars; the storefront shows Shopping Dollars only. */
  @Input() showUsd = false;
  @Input() product: any = null; // The line item/product for opening the modal

  engravingLines = computed(() => {
    const text = this.engravingText;
    if (!text) {
      return [];
    }
    return text.split('\n');
  });
  private engravingModalService = inject(EngravingModalService);

  formatPrice(price: number): string {
    return this.showUsd ? `$${price.toFixed(2)}` : formatRewardAmount(price, this.rewardName());
  }

  viewEngravingDetails(): void {
    if (!this.product || !this.engravingText) {
      return;
    }

    const disabledModalData: DisabledEngravingModalData = {
      product: this.product,
      engravingText: this.engravingText,
    };

    this.engravingModalService.openDisabledModal(disabledModalData);
  }
}
